<ng-container *ngIf="service.inited"><router-outlet></router-outlet></ng-container>